<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!modificaInCorso"
  [dismissableMask]="!modificaInCorso"
  [style]="{width: '350px', maxWidth: '95vw'}"
  styleClass="p-fluid modifica-richiesta-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <!-- Header del dialog -->
    <div class="dialog-header">
      <div class="header-content">
        <span class="material-icons" style="font-size: 28px; margin-right: 8px;">edit</span>
        <h2>Modifica Richiesta</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="modificaInCorso"
        (click)="hide()">
      </button>
    </div>

    <!-- Contenuto principale -->
    <div class="dialog-content">
      <div class="form-grid">
        <!-- Importo Richiesto -->
        <div class="field">
          <label for="importoRichiesto">Importo Richiesto</label>
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-euro"></i>
            </span>
            <p-inputNumber
              id="importoRichiesto"
              [(ngModel)]="importoRichiesto"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [min]="0"
              [showButtons]="false"
              [style]="{width: '100%', textAlign: 'right'}"
              [disabled]="modificaInCorso"
              styleClass="contributo-input">
            </p-inputNumber>
          </div>
        </div>

        <!-- Importo Contributo -->
        <div class="field" *ngIf="importoContributo !== null && importoContributo !== 0">
          <label for="importoContributo">Importo Contributo</label>
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-euro"></i>
            </span>
            <p-inputNumber
              id="importoContributo"
              [(ngModel)]="importoContributo"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [min]="0"
              [showButtons]="false"
              [style]="{width: '100%', textAlign: 'right'}"
              [disabled]="modificaInCorso"
              styleClass="contributo-input">
            </p-inputNumber>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        [disabled]="modificaInCorso"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Salva"
        icon="pi pi-check"
        class="p-button-success"
        [loading]="modificaInCorso"
        (click)="salvaModifiche()">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>
